<template>
    <div>
        <body>
            <van-nav-bar title="商品分类" left-text="" />
            <section class="aui-scrollView">
                <div class="m-scrolltab" data-ydui-scrolltab="">
                    <div class="scrolltab-nav">
                        <a href="javascript:;" :class="isActive==item.id?'scrolltab-item crt':'scrolltab-item'" 
                                v-for="(item,idx) in datalist" v-bind:key="idx" 
                                @click="onclickClass(item.id)">
                            <div class="scrolltab-title" :id="item.id">{{item.text}}</div>
                        </a>

                    </div>
                    <div class="scrolltab-content">
                        <div class="scrolltab-content-item">
                            <!--<div class="aui-meClass-ad">
                                <img src="images/ad-001.jpg" alt="">
                            </div>
                            <h2>紫砂陶瓷</h2>-->
                            <div>
                                <div class="aui-flex-links">
                                    <a href="javascript:;" class="aui-flex-links-item" 
                                    v-for="(items,idy) in childdatalist" v-bind:key="idy" 
                                    @click="onClickItem(items)">
                                        <div class="aui-flex-links-img">
                                            <img :src="items.CategoryImg" alt="">
                                        </div>
                                        <div class="aui-flex-links-text">{{items.CategoryName}}</div>
                                    </a>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
        </body>
    </div>
</template>

<script>
import { TreeSelect, Divider, Button,NavBar } from "vant";
import { debug } from 'util';
export default {
  name: "GoodCategory",
  data() {
    return {
      mainActiveIndex: 0,
      datalist: [],
      childdatalist: [],
      activeId: 1,
      isActive: null,
    };
  },
  methods: {
    /*获取一级分类 */
    GetData() {
      var that = this;
      this.$http.get("Order/GetCategoryList").then((res) => {
        var datalist = res.data.Data;
        datalist = datalist.map((item) => {
          item.text = item.CategoryName;
          item.id = item.ID;
          return item;
        });
        datalist.push({ text: "全部商品", id: 0 });
        this.datalist = datalist;
        that.GetChildData(0);
      });
    },

    GetChildData: function (index) {
      var oldListData = this.datalist;
      var id = this.datalist[index].id;      
      var that = this;
      this.$http.get("Order/GetCategoryList?id=" + id).then((res) => {
        var list = res.data.Data;
        list = list.map((item) => {
          item.text = item.CategoryName;
          item.id = item.ID;
          return item;
        });
        that.activeId=index;
        oldListData[index].children = list;
        that.datalist = oldListData;
      });
    },
    onClickNav(detail) {
      if (this.datalist[detail].id == 0) {
        this.$router.push({
          name: "GoodList",
          params: { categoryId: 0 },
        });
      }
      this.mainActiveIndex = detail || 0;
      this.GetChildData(detail);
    },
    /*获取分类商品列表 */
    onClickItem(item) {
      this.$router.push({
        name: "GoodList",
        params: { categoryId: item.ID },
      });
    },
    /*获取二级分类 */
    GetChildsData(id) {
        var that = this;
        this.$http.get("Order/GetCategoryList?id=" + id).then((res) => {
            var childdatalist = res.data.Data;
            for (let i = 0; i < childdatalist.length; i++) {
            if (childdatalist[i].CategoryImg != null) {
              if (childdatalist[i].CategoryImg.length > 0) {
                childdatalist[i].CategoryImg =
                  that.$file.url +
                  "Images/Mall/Category/" +
                  "/" +
                  childdatalist[i].CategoryImg;
              }
            }
          }
            this.childdatalist = childdatalist;
        });
    },
    /*一级分类点击事件 */
    onclickClass(id){
        if (id == 0) {
            this.$router.push({
                name: "GoodList",
                params: { categoryId: id },
            });
            this.isActive = 0;
        } else {
            this.GetChildsData(id);
            this.isActive = id;
        }
    },
  },
  mounted() {
    this.GetData();
    this.isActive = 1;
    this.GetChildsData(1);
  },
  components: {
    [TreeSelect.name]: TreeSelect,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
  },
};




</script>

<style>
/* 公共样式表css */
html,body {
    color: #333;
    margin: 0;
    height: 100%;
    font-family: "Myriad Set Pro","Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: normal;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

a {
    text-decoration: none;
    color: #000;
}

a, label, button, input, select {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
    border: 0;
}

body {
    background: #ffffff;
    color: #666;
}

html, body, div, dl, dt, dd, ol, ul, li, h1, h2, h3, h4, h5, h6, p, blockquote, pre, button, fieldset, form, input, legend, textarea, th, td {
    margin: 0;
    padding: 0;
}

a {
    text-decoration: none;
    color: #08acee;
}

button {
    outline: 0;
}

img {
    border: 0;
}

button,input,optgroup,select,textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
}

li {
    list-style: none;
}

a {
    color: #666;
}

.clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
}

/* 必要布局样式css */
.aui-flexView {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
}

.aui-scrollView {
    width: 100%;
    height: 100%;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    position: relative;
    margin-top: 0;
    padding-bottom: 50px;
    margin-bottom: 50px;
}

.aui-navBar {
    height: 44px;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    z-index: 1002;
    background: #f9f9f9;
}

.aui-navBar:after {
    content: '';
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
}

.aui-navBar-item {
    height: 44px;
    min-width: 25%;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 25%;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    padding: 0 0.9rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 0.7rem;
    white-space: nowrap;
    overflow: hidden;
    color: #a0a0a0;
    position: relative;
}

.aui-navBar-item:first-child {
    -webkit-box-ordinal-group: 2;
    -webkit-order: 1;
    -ms-flex-order: 1;
    order: 1;
    margin-right: -25%;
    font-size: 0.9rem;
    font-weight: bold;
}

.aui-navBar-item:last-child {
    -webkit-box-ordinal-group: 4;
    -webkit-order: 3;
    -ms-flex-order: 3;
    order: 3;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}

.aui-center {
    -webkit-box-ordinal-group: 3;
    -webkit-order: 2;
    -ms-flex-order: 2;
    order: 2;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 44px;
    width: 60%;
    margin-left: 15%;
}

.aui-center-title {
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    font-size: 0.95rem;
    color: #444444;
}

.icon {
    width: 20px;
    height: 20px;
    display: block;
    border: none;
    float: left;
    background-size: 20px;
    background-repeat: no-repeat;
}

.icon-return {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAD1ElEQVRoQ+3aT2gUVxwH8N93ZrtLsiANBQ9ihBz04MHLXrxIt/6J7GEz7yXsxUIP0os9peeiVdp74iGeRA+ClyWZt0lkSfBPxAg92EspQumhIGhBKSmCkbju/ORpJmx2X6JxJ+Tty85xl515n/ebefN+v9+CdtmBXealLtj1iHcj3I2wYzPQvaUdC2gLZ1siPDg4mM1mswNhGP5p2wQmDpZSfsfMVwBkiehhKpU6VS6XX9sCTxQshDgH4EojjplHlVKXnQNLKX8iol+bYcx8XinV8vlOTUAiERZCjAEYNSBqtVptYHZ29ulOAZuv2y4YQogJAOdMWCIqhWFYsQWrx9EOGFLKG0T0rQH0mpmLSqk7NmE/G5zP51N9fX03dQQNz+xLz/NOT01N/WYb9rPAuVzui/7+/gqAggH7XxRFx6enp/+wEbtlcKlU6qnVajMAThiwz3zfz09OTv5tK3ZL4NXd020iOmrA/lOv1/MzMzNPbMZ+MrhQKOzJZDJ3AeQM2McAvgnD8Lnt2E8CSym/IqK7RHTEgP2diE4qpf7vBOxHwVLKvUS0SEQHDdgHy8vLhfn5+Vedgt0UXCwWD/i+vwBgwICtrqysyGq1utJJ2A3BxWJxwPf9RQD7DKDy0tLSmYWFhbedhjWCgyA47HnePSLSt/O6g5mvKaW+JyLuRGwLeGho6IjnefcBfGnAjiulfuxUaDzutb308PDw0SiK5gDsMWCtSvHamfT34CAIjnmeN0dEPY0n4w/HOIDpdi6y079l5no6nX6kKy864/mamXVkM01YAtpJpnaa2bL+LOs0VuezfwE45DK2wfavBj9tfv0ws1PRjcHM/ApBEPzged6EYaFyET32/iEVQowCGDOhmfkWgEd2PZFbHw2AF2EYTqytSlLKs8x8FYaVipkvKKV+2fpl7PvFumVYSlli5psAUs5vPGKgEEKXbsLm15T+3rmtZYzWGxEA1dV2SXOw3UoeGiKtqxu6ymHaarqVHsbo1WRCo3XVY93BzG4VAGLdyMjIwXq9rgsBLbkxM7tV4onRH6l+uFXEi9G6vsXM9wAcNtzebpVpGxYyXRi4vUG51q1CfIzWBfne3l79yjpmiLRbrZYYWCgUMplMRm9OTP0lt5ppMXqzDiIRudUubbiVN+sR11xriMfuDf8FwMxvoyjK2dQ+TaxoJYS4COBnw0J2SSl10ZZEMTHwJoWEs2EYXncSrFFNf0xbTKVSJ8rl8htnwRqm+8npdHp/pVJ5bAt0bcGxbUDbPZ5En+HtHmwS5++Ck5hFm8/RjbDN0UlibLsuwu8A8H6n2z7rvb0AAAAASUVORK5CYII=');
}

.m-scrolltab {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
}

.scrolltab-nav {
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    z-index: 1;
}

.scrolltab-item:after {
    content: '';
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #D9D9D9;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
}

.scrolltab-item {
    height: 4rem;
    position: relative;
    z-index: 1;
    width: 90px;
    display: block;
    line-height: 4rem;
    text-align: center;
    background: #f0f0f0;
}

.scrolltab-item:before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    height: 100%;
    border-right: 1px solid #d0d0d0;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0;
}

.scrolltab-item.crt:before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    height: 100%;
    border-right: 1px solid #ffffff;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0;
}

.scrolltab-title {
    font-size: 0.8rem;
    color: #666;
    overflow-x: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    white-space: nowrap;
}

.scrolltab-content {
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 0.8rem 0.8rem 0.8rem 0.8rem;
    position: relative;
}

.scrolltab-item.crt {
    background-color: #ffffff;
    position: relative;
}

.scrolltab-item.crt .scrolltab-title {
    color: #c21f3a;
}

.aui-ad-head a {
    width: 30%;
    display: block;
    float: left;
    margin-right: 5%;
}

.aui-ad-head a img {
    width: 100%;
    display: block;
    border-radius: 5px;
}

.aui-ad-head {
    padding-bottom: 15px;
    background: #fff;
    padding: 10px;
}

.scrolltab-content-item h2 {
    color: #000000;
    font-size: 14px;
    font-weight: normal;
    padding-top: 20px;
    text-align: center;
    position: relative;
}

.aui-flex-box {
    padding: 1px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.aui-flex-box-bd {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    min-width: 0;
    font-size: 0.9rem;
    color: #444;
}

.aui-flex-box-fr {
    text-align: right;
    color: #bbbbbb;
    padding-right: 15px;
    position: relative;
    font-size: 0.8rem;
}

.aui-flex-box-fr:after {
    content: " ";
    display: inline-block;
    height: 7px;
    width: 7px;
    border-width: 2px 2px 0 0;
    border-color: #bbbbbb;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    position: relative;
    top: -2px;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: 2px;
    border-radius: 1px;
}

.aui-flex-links {
    padding: 0 8px;
    position: relative;
    overflow: hidden;
    background: #fff;
    margin-bottom: 15px;
}

.aui-flex-links-item {
    position: relative;
    float: left;
    padding: 5px 0;
    width: 27.333333%;
    box-sizing: border-box;
    margin: 0 3%;
}

.aui-flex-links-img {
    width: 100%;
    height: 100%;
    margin: 0 auto;
}

.aui-flex-links-img img {
    width: 100%;
    height: auto;
    display: block;
    border: none;
}

.aui-flex-links-text {
    color: #444;
    font-size: 12px;
    text-align: center;
}

.aui-class-ad-img a img {
    width: 100%;
    height: auto;
    display: block;
    border: none;
    border-radius: 4px;
}

.m-slider {
    overflow-x: hidden;
    width: 100%;
    position: relative;
}

.slider-wrapper {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 100%;
    -webkit-transform: translate3d(0px, 0px, 0px);
    transform: translate3d(0px, 0px, 0px);
    position: relative;
    z-index: 1;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
}

.slider-item {
    width: 100%;
    height: 100%;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
}

.slider-item img {
    width: 100%;
    height: auto;
    display: block;
    border: none;
}

.slider-pagination {
    text-align: right;
    position: absolute;
    width: 100%;
    z-index: 2;
    right: 0;
    bottom: 5px;
    pointer-events: none;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    -ms-flex-align: end;
    align-items: flex-end;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.slider-pagination > .slider-pagination-item {
    margin: 0 .25rem;
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background-color: #d8d8d8;
}

.slider-pagination > .slider-pagination-item.slider-pagination-item-active {
    background-color: #ff552e;
    border-radius: 10px;
}

.aui-class-content {
    padding-top: 20px;
}

.aui-meClass-ad img {
    width: 100%;
}

.scrolltab-item.crt .scrolltab-title:after {
    content: '';
    width: 4px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #c21f3a;
}

.scrolltab-content-item h2:after {
    content: '';
    position: absolute;
    z-index: 0;
    bottom: 10px;
    right: 60px;
    width: 12%;
    height: 1px;
    border-bottom: 1px solid #000000;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
}

.scrolltab-content-item h2:before {
    content: '';
    position: absolute;
    z-index: 0;
    bottom: 10px;
    left: 60px;
    width: 12%;
    height: 1px;
    border-bottom: 1px solid #000000;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
}

.aui-footer {
    width: 100%;
    position: relative;
    z-index: 100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 7px 5px 7px 5px;
    background: #ffffff;
}

.aui-footer:after {
    content: '';
    position: absolute;
    z-index: 0;
    top: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    border-top: 1px solid #e4e4e4;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
}

.aui-tabBar-item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: #979797;
}

.aui-tabBar-item-text {
    display: inline-block;
    font-size: 0.65rem;
    color: #3b4048;
    padding-top: 2px;
}

.aui-tabBar-item-active .aui-tabBar-item-text {
    color: #b6172f;
}

.aui-footer-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 49;
}

</style>